import React, { FC } from 'react';
import hourglass from 'images/hourglass.svg';
import { useTranslation } from 'react-i18next';
import { Framework } from 'client/components/Framework';
import { SvgImage } from 'common/components/SvgImage';
import styled from 'styled-components';
import { Head } from 'common/components/Head';
import { Link } from 'react-router-dom';
import { Meta } from 'types/meta';

const ActionImage = styled(SvgImage)`
  max-height: 100px;
  margin-top: 80px;
  margin-bottom: 80px;
`;

// todo can't we use standard navigation button?
const NavigationButton = styled.div<{ color: string }>`
  height: 65px;
  width: 100%;
  background-color: ${({ color }) => color};
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 20px 0 0 0;
  cursor: pointer;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    text-decoration: none;
  }
`;

const Text = styled.p`
  color: #ffffff;
  font-size: 18px;
  max-width: 230px;
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
  margin-bottom: 0px;
  text-align: center;
`;

const BackLink = styled(Link)`
  width: 100%;
  :hover {
    text-decoration: none;
  }
`;

export const ActionSentPage: FC<{ meta: Meta }> = ({ meta }) => {
  const { t } = useTranslation();
  return (
    <Framework locales={meta.locales} logo={meta.logo} color={meta.color}>
      <Head title={t('ActionSentPage')} description={t('ActionSentPage')} />
      <ActionImage color={meta.color} source={hourglass} />
      <h1 style={{ textAlign: 'center' }}>{t('requestSent')}</h1>
      <BackLink to=".." style={{ width: '100%' }}>
        <NavigationButton color={meta.color}>
          <Text>Go back</Text>
        </NavigationButton>
      </BackLink>
    </Framework>
  );
};
